import PinIcon from '@mui/icons-material/Pin';
import { useTranslation } from "react-i18next";
import ActionButton from "./ActionButton";
import { useDispatch } from "react-redux";
import { setPlateNumberAddParams } from "@/features/modals/modalsSlice";

const ActionButtonAddPlateNumber = ({
  channelId
}) => {
  const dispatch = useDispatch()
  const { t } = useTranslation();
  
  return (
    <ActionButton
      color="secondary"
      variant="outlined"
      startIcon={<PinIcon/>}
      onClick={() => dispatch(setPlateNumberAddParams({
        channelId,
      }))}
    > 
      
      {t('add_number')}
    </ActionButton>
  );
}

export default ActionButtonAddPlateNumber;